import {
  Component,
  ViewChild,
  ElementRef,
  AfterViewInit,
  ChangeDetectorRef,
  Input,
  OnInit,
} from "@angular/core";
import { ActivatedRoute, Router, Params } from "@angular/router";
import { Location } from "@angular/common";

import { switchMap } from "rxjs/operators";

import { Client } from "../../shared/models/client.model";
import { Salon } from "../../shared/models/salon.model";
import { ClientService } from "../../shared/services/client.service";
import { SalonService } from "../../shared/services/salon.service";
import { UserService } from "../../shared/services/user.service";
import { DialogsService } from "../../shared/services/dialogs/dialogs.service";
import { StripeService } from "../../shared/services/stripe.service";
import { environment } from "../../../environments/environment";
import { firstValueFrom } from "rxjs";
import { loadStripe } from "@stripe/stripe-js";

@Component({
  selector: "sm-client-cardrequest",
  templateUrl: "client-cardrequest.component.html",
  styleUrls: ["client-cardrequest.component.scss"],
})
export class ClientCardRequestComponent implements OnInit, AfterViewInit {
  public isLoading: boolean;

  public errorOccurred: boolean;

  public requestHash: string;

  public client: Client;
  public salon: Salon;
  public clientBookingPayments: number = 1;
  public refreshStripe: number = 0;

  @ViewChild("paymentElement") paymentElementRef: ElementRef;
  @Input() savingStripe: boolean = false;

  public stripe;
  public elements;
  public cardErrors;
  public newStripeClient;
  public paymentElement;
  public saveCardChecked;
  public cardInputComplete = false;

  public buttonText: string;
  public requirementText: string;
  public cancellationPolicy: string;
  public stripeReady: boolean = false;

  public totalPrice;
  public currency;
  public cardInfo = {
    brand: "",
    last4: "",
    exp_month: "",
    exp_year: "",
    funding: "",
  };

  public completedSaving: boolean = false;
  constructor(
    private clientService: ClientService,

        private stripeService: StripeService,
    private salonService: SalonService,
    private changeDetectorRef: ChangeDetectorRef,
    private dialogsService: DialogsService,
    private userService: UserService,
    private router: Router,
    private route: ActivatedRoute,
    private ref: ChangeDetectorRef,
    private location: Location
  ) {
    this.isLoading = true;
  }

  public async ngOnInit() {
    this.stripe = await loadStripe(environment.stripePublishableKey);
    this.clientBookingPayments = 3;
    this.fetchCardRequest();
  }

  public ngAfterViewInit() {
    if (this.client && this.salon) {
      this.setupStripeElements();
    }
  }

  public fetchCardRequest() {
    this.route.params
      .pipe(
        switchMap((params: Params) => {
          this.requestHash = params["requestHash"];
          return this.clientService.getClientCardRequest(this.requestHash);
        })
      )
      .subscribe(
        (response) => {
          this.client = response.client;
          this.completedSaving = response.completedSaving;
          this.changeDetectorRef.detectChanges();

          this.salonService
            .loadSalonByID(this.client.salonID)
            .subscribe((salon: Salon) => {
              this.salon = salon;
              this.clientBookingPayments = 1;
              this.refreshStripe++;
              if (this.paymentElementRef) {
                this.setupStripeElements();
              }
              this.changeDetectorRef.detectChanges();
            });
        },
        (err) => {
          this.isLoading = false;
          this.errorOccurred = true;
          this.changeDetectorRef.detectChanges();
        }
      );
  }

  public async onSave() {
    this.savingStripe = true;

    const { error: submitError } = await this.elements.submit();
    if (submitError) {
      this.savingStripe = false;
      this.cardErrors = submitError.message;
      this.ref.detectChanges();
      return;
    }

    try {
      const clientSecret = await this.stripeService
        .clientIntentSecret({
          clientID: (this.client as any).id,
          newClient: this.newStripeClient,
        })
        .toPromise();

      const result = await this.stripe.confirmSetup({
        elements: this.elements,
        clientSecret,
        confirmParams: {
          return_url: window.location.href,
        },
        redirect: "if_required",
      });

      if (result.error) {
        this.savingStripe = false;
        if (result.error.code === "card_declined") {
          this.cardErrors = `Sorry we couldn't process your card: card declined`;
        } else {
          this.cardErrors = `Sorry we couldn't process your card: ${result.error.message}`;
        }
        this.ref.detectChanges();
      } else if (result.setupIntent?.status === "succeeded") {
        this.completedSaving = true;
        await firstValueFrom(this.clientService.updateClientCardRequest(this.requestHash));
      }
    } catch (err) {
      this.savingStripe = false;
      this.cardErrors = `Sorry we couldn't process your card: ${err.message || err}`;
      this.ref.detectChanges();
    }
  };

  public setupStripeElements() {
    this.elements = this.stripe.elements({
      mode: "setup",
      currency: this.salon?.getStripeCurrency() || "usd",
    });
    this.paymentElement = this.elements.create("payment");
    this.paymentElement.mount(this.paymentElementRef.nativeElement);
    this.paymentElement.on("ready", () => {
      this.stripeReady = true;
      this.ref.detectChanges();
    });
    this.paymentElement.on("change", (event) => {
      this.cardInputComplete = event.complete;
      this.cardErrors = event.error?.message || null;
    });
  }
}
